import * as types from 'PointOfSale/modules/cepCard/state/types';

export const INITIAL_STATE = {
  servedMealsCount: 0,
  lastMealServedAt: null,
  fetching: false,
  processedMealsCount: 0,
  error: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.MEAL_COUNTER_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.MEAL_COUNTER_LOADING:
      return {
        ...state,
        fetching: payload,
      };
    case types.INCREMENT_SERVED_MEALS_COUNT:
      return {
        ...state,
        servedMealsCount: state.servedMealsCount + payload,
        lastMealServedAt: new Date(),
      };
    case types.MEAL_COUNTER_INCREMENT_PROCESSED_MEAL_COUNTS:
      return {
        ...state,
        processedMealsCount: state.processedMealsCount + payload,
      };
    case types.MEAL_COUNTER_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/state/reducer.js